import { FC, memo } from 'react';
import classNames from 'classnames';
import { Typography } from 'antd';

import { Popover } from 'componets/ui';

import { useTranslate } from 'hooks';

import Utils from 'utils/utils';

import { ReactComponent as InfoIcon } from 'assets/icons/info-grey.svg';

import s from './index.module.scss';
import { Tooltip } from 'antd/es';

export const SaleProjectInterests: FC<{ paid: number; expected: number }> = memo(
	({ paid, expected }) => {
		const {
			sellerEarningsText,
			buyerEarningsText,
			buyerEarningsTwoText,
			totalIncomeText,
			estimatedIncomeText,
		} = useTranslate([
			'sellerEarningsText',
			'buyerEarningsText',
			'totalIncomeText',
			'estimatedIncomeText',
			'buyerEarningsTwoText',
		]);

		return (
			<>
				<div className={classNames(s.row, s.rowFirst)}>
					<Typography.Text type="secondary" className={s.rowText}>
						{sellerEarningsText}
						<Popover content={totalIncomeText} trigger="hover">
							<span className={s.cover}>
								<InfoIcon />
							</span>
						</Popover>
					</Typography.Text>
					<span>{Utils.moneyFormat(paid)}</span>
				</div>
				<div className={s.row}>
					<Typography.Text type="secondary" className={s.rowText}>
						{buyerEarningsText}
						&nbsp;
						<span className={s.cover}>
							{buyerEarningsTwoText}
							<Tooltip
								overlayClassName="popover"
								title={estimatedIncomeText}
								trigger="hover"
								placement="top"
							>
								<InfoIcon />
							</Tooltip>
						</span>
					</Typography.Text>
					<span>{Utils.moneyFormat(expected)}</span>
				</div>
			</>
		);
	},
);
